import { useEffect, useState } from 'react';

import { hubConnection } from 'signalr-no-jquery';

import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import { TokenService } from '../../app/he-thong/chung-thu-so/TokenService';
import { AppStorage } from '../../service/UserStorage';

import { translate, translateError } from '../language';

import { InfoDialogService } from '../../AppInfoDialog';
import { ConfirmDialogService } from '../../AppConfirmDialog';

import { LoadingService } from '../../AppLoading';

import { Service } from '../../service';
import EventEmitter from '../../utils/EventEmitter';

class SignService extends Service {

  static entity = 'app/sign-service';

  static sign(data: any): Promise<any> {
    return this.axios.post(`${this.entity}`, data).then(res => res.data);
  }

  static Invoice = 'Invoice';
  static Declare = 'Declare';
  static WrongInvoice = 'WrongInvoice';
  static InvoiceCode = 'InvoiceCode';
  static InvoiceSummary = 'Summary';
  static StatementInvoice = 'StatementInvoice';
  static StatementInvoiceBuyer = 'StatementInvoiceBuyer';


}

export const useSign = ({ onComplete }) => {

  const [display, setDisplay] = useState(false);
  const [tokens, setTokens] = useState([]);
  const [selectedToken] = useState(null);

  const [plugCommand, setPlugCommand] = useState(null);

  useEffect(() => {
    if (plugCommand) {
      getTokens().then(tokens => {
        if (tokens && tokens.length) {
          if (tokens.length === 1) {
            signByToken(tokens[0]);
          } else {
            let defaultSign = 0, defaultToken;
            tokens.forEach(token => {
              if (token.defaultSign) {
                defaultSign++;
                defaultToken = token;
              }
            });
            if (defaultSign === 1) {
              signByToken(defaultToken);
            } else {
              setDisplay(true);
            }
          }
        } else {
          ConfirmDialogService.showInvalid('Bạn chưa đăng ký chứng thư số hoặc chưa được phân quyền chứng thư số.');
        }
      });
    }
  }, [plugCommand]); // eslint-disable-line react-hooks/exhaustive-deps

  const notificeEvent = () => {
    EventEmitter.emit("reloadSearchInvoiceSign");
  }

  const getTokens = () => {
    return new Promise<any>((resolve) => {
      if (tokens && tokens.length) {
        resolve(tokens);
      } else {
        TokenService.getList({ Used: true, MaxResultCount: 1000 }).then(({ items }) => {
          setTokens(items);
          resolve(items);
        }).catch(() => {
          resolve(tokens);
        });
      }
    });
  }

  const sign = (PlugCommand?: any) => {
    setPlugCommand(PlugCommand);
  }

  const signByToken = (token) => {
    if (token.tokenType === 0) {
      plugCommand.SerialNumber = token.serialNumber;
      Sign(plugCommand).then(result => {
        if (onComplete) {
          onComplete(result);
          notificeEvent();
        }
      });
    } else {
      let signType, ids;
      switch (plugCommand.CommandName) {
        case "SignInvoices":
          signType = SignService.Invoice;
          ids = plugCommand.InvoiceIdArray;
          break;
        case "SignSummary":
          signType = SignService.InvoiceSummary;
          ids = plugCommand.InvoiceIdArray;
          break;
        case "SignDeclaration":
          signType = SignService.Declare;
          ids = [plugCommand.Id];
          break;
        case "SignSS04":
          signType = SignService.WrongInvoice;
          ids = [plugCommand.Id];
          break;
        case "StatementInvoice":
          signType = SignService.StatementInvoice;
          ids = plugCommand.InvoiceIdArray;
          break;
        case "StatementInvoiceBuyer":
          signType = SignService.StatementInvoiceBuyer;
          ids = plugCommand.InvoiceIdArray;
          break;
      }
      signService({ signType, ids, tokenInfo: token });
    }
  }
  const signService = (singInfo) => {
    SignService.sign(singInfo).then(result => {
      if (onComplete) {
        onComplete(result);
        notificeEvent();
      }
    }).catch(({ response }) => {
      ConfirmDialogService.showInvalid(translateError(response));
    });
  }
  const onSelectionChange = (e) => {
    signByToken(e.value);
    setDisplay(false);
  }

  const renderSign = () => {
    return (
      <Dialog header="Chọn chứng thư số" visible={display} style={{ width: '60rem' }} position="top" onHide={() => setDisplay(false)}>
        <DataTable value={tokens} selectionMode="single" selection={selectedToken} onSelectionChange={onSelectionChange} dataKey="id" responsiveLayout="scroll">
          <Column field="vender" header="Tên đơn vị cấp chứng thư số"></Column>
          <Column field="subjectName" header="Tên chủ sở hữu"></Column>
          <Column field="tokenType" header="Loại" body={rowData => TokenService.tokenTypes[rowData.tokenType].label}></Column>
        </DataTable>
      </Dialog>
    );
  }

  return { renderSign, sign };
}

export const Sign = (PlugCommand: any) => {

  LoadingService.start();

  let connectionHub;
  return new Promise<any>((resolve, reject) => {
    const options: any = {
      'Content-Type': 'application/json',
      'Accept': '*/*',
      qs: {
        'Access-Control-Allow-Private-Network': true
      }
    };
    connectionHub = hubConnection('http://localhost:16080', options);

    const hubProxy = connectionHub.createHubProxy('handlerHub');
    hubProxy.on('reponseResult', (resultText) => {
      const result = JSON.parse(resultText);
      if (result.code === 1) {
        resolve(result);
      } else {
        reject();
        ConfirmDialogService.showInvalid(translate(`ErrorCode-${result.code}`, result.message));
      }
    });

    const data = {
      "BrowserInfo": {
        "Cookie": document.cookie,
        "UserAgent": navigator.userAgent,
        "UserName": AppStorage.get('UserName'),
        "Pass": AppStorage.get('Pass'),
        "LinkApi": "https://api-hddt.wiinvoice.vn/api/app/"
      },
      "PlugCommand": PlugCommand
    };

    connectionHub.start().done(() => {
      hubProxy.invoke('processMessage', JSON.stringify(data)).then();
    }).fail(() => {
      InfoDialogService.show({
        header: 'Ký điện tử không thành công',
        width: '50rem',
        body: (
          <div className="grid">
            <div className="col-2 text-center">
              <img src="/images/usb-not-connected-icon.png" alt="" style={{ width: '80%' }} />
            </div>
            <div className="col-10">
              <p>Hãy kiểm tra các trường hợp dưới đây để khắc phục vấn đề của bạn</p>
              <p><b>1.</b> Bạn chưa cài đặt công cụ <b>WIINVOICE Plugin</b></p>
              <p className="pl-4">Hãy cài đặt WIINVOICE Plugin để tiếp tục.</p>
              <p className="pl-4">
                <a href="assets/tool/setup.exe" rel="noreferrer" target="_blank" className="text-lg mr-5"><i className="pi pi-download mr-2"></i>Tải bộ cài</a>
                <a href={'#'} rel="noreferrer" target="_blank" className="text-lg"><i className="pi pi-info-circle mr-2"></i>Xem hướng dẫn cài đặt</a>
              </p>
              <p><b>2.</b> Bạn đã cài đặt công cụ <b>WIINVOICE Plugin</b></p>
              <p className="pl-4">Hãy mở công cụ WIINVOICE Plugin trước khi ký điện tử</p>
              <p className="pl-4">
                <a href={`minvoice:${AppStorage.get('tenant')}`} className="text-lg"><i className="pi pi-info-circle mr-2"></i>Mở WIINVOICE Plugin</a>
              </p>
            </div>
          </div>
        )
      });
      reject();
    });
  }).finally(() => {
    if (connectionHub) {
      connectionHub.stop();
    }
    LoadingService.stop();
  })
}